import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { DATA_LAKE_API_ROUTES, DATA_LAKE_CONFIG_QUERY_KEYS, DATA_LAKE_BACKEND_QUERY_KEYS } from "data-lake/Constants";
import UserNotification from "util/UserNotification";
import { qualifyUrl } from "util/URLUtils";
const createDataLakeBackend = async (backend) => fetch("POST", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.backend.base().url), { ...backend });
const updateDataLakeBackend = async (backend) => fetch("PUT", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.backend.update(backend.id).url), { ...backend });
const deleteDataLakeBackend = async (id) => fetch("DELETE", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.backend.delete(id).url));
const useCreateDataLakeBackend = (successHandler = void 0) => {
  const queryClient = useQueryClient();
  const {
    mutateAsync,
    isPending: isLoading,
    error
  } = useMutation({
    mutationFn: createDataLakeBackend,
    onSuccess: () => {
      UserNotification.success("Successfully created Data Lake backend.");
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_QUERY_KEYS });
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_CONFIG_QUERY_KEYS });
      if (successHandler) {
        successHandler();
      }
    },
    onError: (err) => {
      UserNotification.error(
        `Error creating Data Lake backend: ${err.toString()}`,
        "Unable to create Data Lake backend."
      );
    }
  });
  return {
    mutateAsync,
    isLoading,
    error
  };
};
const useUpdateDataLakeBackend = (successHandler = void 0) => {
  const queryClient = useQueryClient();
  const {
    mutateAsync,
    isPending: isLoading,
    error
  } = useMutation({
    mutationFn: updateDataLakeBackend,
    onSuccess: () => {
      UserNotification.success("Successfully updated Data Lake backend");
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_QUERY_KEYS });
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_CONFIG_QUERY_KEYS });
      if (successHandler) {
        successHandler();
      }
    },
    onError: (err) => {
      UserNotification.error(
        `Error updating Data Lake backend: ${err.toString()}`,
        "Unable to update Data Lake backend."
      );
    }
  });
  return {
    mutateAsync,
    isLoading,
    error
  };
};
const useDeleteDataLakeBackend = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: deleteDataLakeBackend,
    onSuccess: () => {
      UserNotification.success("Successfully deleted Data Lake backend");
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_QUERY_KEYS });
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_CONFIG_QUERY_KEYS });
    },
    onError: (err) => {
      UserNotification.error(
        `Error deleting Data Lake backend: ${err.toString()}`,
        "Unable to delete Data Lake backend."
      );
    }
  });
  return {
    mutateAsync,
    isLoading
  };
};
export { useCreateDataLakeBackend, useUpdateDataLakeBackend, useDeleteDataLakeBackend };
